import styled from 'styled-components';

export const DataPointSection = styled.div`
    padding-bottom: 20px;
`;

export const DataPointSectionHeader = styled.div`
    display: flex;
    flex-direction: column;

    owc-typography {
        padding-bottom: 5px;
    }
`;

export const DataPointSectionContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px 40px;
`;
